module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-8-latka-9-latka.17c8821f.png";